var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
let RobberyDuringAbsenceQuestion = class RobberyDuringAbsenceQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    updateClaim(isDuringAbsence) {
        this.updateAndSaveQualification({
            qualificationPayload: { isDuringAbsence },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.robbery.during_absence.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.robbery.during_absence.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.isDuringAbsence === null) {
            return null;
        }
        return this.qualification.isDuringAbsence
            ? this.$tc('claim.qualification.robbery.during_absence.answer.yes')
            : this.$tc('claim.qualification.robbery.during_absence.answer.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], RobberyDuringAbsenceQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], RobberyDuringAbsenceQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], RobberyDuringAbsenceQuestion.prototype, "updateAndSaveQualification", void 0);
RobberyDuringAbsenceQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], RobberyDuringAbsenceQuestion);
export default RobberyDuringAbsenceQuestion;
